/**
 * Created by lycheng on 2017/11/23.
 * 所有页面都要引入，基础公共方法
 */

import 'babel-polyfill'
import { checkSupport } from 'js/libs/utils'
import 'js/libs/utils-checkbox'
import 'js/libs/utils-modal'
import 'js/libs/utils-alerts'
import 'js/libs/utils-header-sidebar'
import 'js/libs/utils-footer'

var support = checkSupport()
Date.prototype.Format = function (fmt) { // eslint-disable-line
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
if (!support && window.location.href.indexOf('/hera/unSupported') < 0) {
  window.location.href = '/hera/unSupported'
}



// WEBPACK FOOTER //
// ./src/js/libs/common.js